import { NotebookTabs, Plus } from 'lucide-react'
import { MdSearch } from 'react-icons/md'

import type { SearchFormPeriodData } from '@/modules/report/hooks/use-search-form-report-period.hook'
import { DatePickerFormComponent } from '@/modules/shared/components/date-picker-form.component'
import { FabComponent } from '@/modules/shared/components/fab.component'
import { Button } from '@/modules/shared/components/ui/button'
import { Form } from '@/modules/shared/components/ui/form'

import { ScheduleCardComponent } from '../components/schedule-card.component'
import { SCHEDULE_FAB } from '../constants/schedule-fab.constant'
import type {
  SearchSchedulesPeriodData,
  useScheduleList,
} from '../hooks/use-schedule-list.hook'

type ScheduleListInterfaceProps = ReturnType<typeof useScheduleList> & {
  isDashoboardPage?: boolean
}

export default function ScheduleListInterface({
  schedules,
  form,
  handleFetchSchedules,
  selectedSchedule,
  handleSelectActionToStart,
  handleViewSchedule,
  isDashoboardPage = false,
  handleSelectScheduleToStartActions,
}: ScheduleListInterfaceProps) {
  return (
    <div className="min-h-[75vh] mt-4">
      {!isDashoboardPage && (
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(handleFetchSchedules)}
            className="flex-1 flex items-end space-x-2 flex-row"
          >
            <DatePickerFormComponent<SearchSchedulesPeriodData>
              control={form.control}
              name="dtStart"
              label="Data Inicio"
            />
            <DatePickerFormComponent<SearchFormPeriodData>
              control={form.control}
              name="dtEnd"
              label="Data Fim"
            />
            <Button variant="outline" type="submit">
              <MdSearch size={24} />
            </Button>
          </form>
        </Form>
      )}

      <div className="mt-2 grid  gap-2 md:grid-cols-2 lg:grid-cols-3">
        {!schedules?.length && (
          <div className="col-span-3 min-h-[40vh] flex items-center justify-center flex-col">
            <NotebookTabs size={48} className="text-gray-300 mb-7" />
            <p className="text-gray-300">Nenhum agendamento encontrado</p>
          </div>
        )}
        {schedules?.map((agendamento) => (
          <ScheduleCardComponent
            handleViewSchedule={handleViewSchedule}
            scheduleSelected={selectedSchedule}
            key={agendamento.idAgendamento}
            schedule={agendamento}
            selectable={!isDashoboardPage}
            onClick={
              isDashoboardPage
                ? null
                : () => handleSelectScheduleToStartActions(agendamento)
            }
          />
        ))}
      </div>
      {!isDashoboardPage && (
        <>
          {selectedSchedule ? (
            <FabComponent
              items={SCHEDULE_FAB.map((item) => ({
                id: item.id,
                icon: item.icon,
                type: item.type,
                disabled: false,
                label: item.label,
              }))}
              action={handleSelectActionToStart}
            />
          ) : (
            <FabComponent
              items={[
                {
                  id: '7',
                  icon: Plus,
                  type: 'add',
                  disabled: false,
                  label: 'Adicionar',
                },
              ]}
              action={handleSelectActionToStart}
            />
          )}
        </>
      )}
    </div>
  )
}
